<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header" style="text-align: center">
                {{ $t("text.assignedOrders.title") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center">
                  <div>
                    <img src="@/assets/img/truck (1).png" width="80%" />
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ orderCount }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3 co_order"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <!-- <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-6 text-center section___column_1">
                <h3 class="our__branches__banner__title">Assign Truck</h3>
              </div>
              <div class="col-md-6 text-right section___column_2">
                <div class="row align-items-center"></div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  width="170"
                  field="companyName"
                  :headerText="$t('text.assignedOrders.companyName')"
                ></e-column>
                <e-column
                  width="240"
                  field="contactName"
                  :headerText="$t('text.assignedOrders.contactName')"
                ></e-column>
                <e-column
                  width="180"
                  field="contactPhone"
                  :headerText="$t('text.assignedOrders.contactPhone')"
                ></e-column>
                <e-column
                  width="180"
                  field="driverName"
                  :headerText="$t('text.assignedOrders.driverName')"
                ></e-column>
                <e-column
                  width="180"
                  field="state"
                  :headerText="$t('text.assignedOrders.state')"
                ></e-column>
                <e-column
                  width="180"
                  field="quantity"
                  :headerText="$t('text.assignedOrders.quantity')"
                ></e-column>
                <e-column
                  width="180"
                  field="status"
                  :headerText="$t('text.assignedOrders.status')"
                ></e-column>
                <e-column
                  width="180"
                  field="productName"
                  :headerText="$t('text.assignedOrders.product')"
                ></e-column>
                <!-- <e-column
                  width="450"
                  :template="buttonsTemplate"
                  headerText="Actions"
                ></e-column> -->
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <!-- <EditZoneModal :id="zoneId" :zoneName="zoneName"></EditZoneModal> -->
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Assigned Orders :: Epump Portal",
  name: "AssignTruck",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      orderCount: 0,
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.$eventHub.$on("assignTruck", (branchId) => {
      this.assignTruck(branchId);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("assignTruck");
  },
  watch: {},
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getOrders();
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    assignTruck(truckId) {
      const data = {
        driverId: this.$route.query.id,
        truckId,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Delivery/AssignTruckToDriver`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message:
              response.status === 200
                ? this.$t("text.assignedOrders.successfullyAssignedTruck")
                : response.data.message,
            type: "success",
            duration: 4000,
          });
          this.$router.push({
            name: "peddling_manage_drivers",
            query: this.$route.query.companyId,
          });
        })
        .catch((error) => {
          $(".loader").hide();
          this.$toast.open({
            message: this.$t("text.assignedOrders.failedToAssign"),
            type: "error",
            duration: 4000,
          });
        });
    },
    getOrders() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/DriverOrders/${this.$route.query.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          response.data.forEach((zone, index) => {
            zone.index = index + 1;
          });
          this.showLoader = false;
          this.orderCount = response.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
  },
};
</script>
